module.exports = __webpack_public_path__ + "img/team-list5.27a6cbf5.png";